import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

const MomentosPieChartPanelControl = ({ bloquesPedagogicos }) => {
  const options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Rendimiento Estudiantil por momentos',
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f}%',
        },
      },
    },
    series: [
      {
        name: 'Rendimiento',
        data: bloquesPedagogicos.map((bloque) => ({
          name: bloque.nombre,
          y: 48,
        })),
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MomentosPieChartPanelControl;
